import { render, staticRenderFns } from "./NearbyBasketsList.vue?vue&type=template&id=02ee9f8e&scoped=true"
import script from "./NearbyBasketsList.vue?vue&type=script&setup=true&lang=js"
export * from "./NearbyBasketsList.vue?vue&type=script&setup=true&lang=js"
import style0 from "./NearbyBasketsList.vue?vue&type=style&index=0&id=02ee9f8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ee9f8e",
  null
  
)

export default component.exports